import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/data";

const NAV = [
  { label: "Services", id: "services" },
  { label: "Équipements", id: "equipements" },
  { label: "Calculatrice", id: "calculatrice" },
  { label: "Pourquoi nous", id: "apropos" },
  { label: "FAQ", id: "faq" },
];

const Header = () => {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header data-testid="site-header" className="fixed top-0 inset-x-0 z-50 glass">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <button data-testid="header-logo" onClick={() => go("accueil")} className="flex items-center">
          <img src="/images/logo.png" alt="Solubail — Financement d'équipements" className="h-9 w-auto rounded-md bg-white px-2.5 py-1 ring-1 ring-slate-900/10 shadow-sm" />
        </button>

        <nav data-testid="header-nav" className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-link-${item.id}`}
              onClick={() => go(item.id)}
              className="text-sm font-medium text-slate-600 hover:text-sky-600 transition-colors duration-300"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="header-phone-button"
            href={PHONE_TEL}
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-sky-400 px-5 py-2.5 text-sm font-bold text-[#0A1220] hover:bg-sky-300 transition-colors duration-300"
          >
            <Phone className="w-4 h-4" />
            {PHONE_DISPLAY}
          </a>
          <button
            data-testid="header-menu-button"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-slate-900"
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="header-mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="lg:hidden overflow-hidden border-t border-slate-900/10"
          >
            <div className="px-6 py-4 flex flex-col gap-1 bg-[#F7F9FC]/95">
              {NAV.map((item) => (
                <button
                  key={item.id}
                  data-testid={`mobile-nav-link-${item.id}`}
                  onClick={() => go(item.id)}
                  className="text-left py-3 text-base font-medium text-slate-700 hover:text-sky-600 border-b border-slate-900/10 transition-colors"
                >
                  {item.label}
                </button>
              ))}
              <a
                data-testid="mobile-phone-button"
                href={PHONE_TEL}
                className="mt-4 inline-flex items-center justify-center gap-2 rounded-full bg-sky-400 px-5 py-3 text-sm font-bold text-[#0A1220]"
              >
                <Phone className="w-4 h-4" />
                Appeler le {PHONE_DISPLAY}
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
